/**
 * Helpers for the Reppi admin API (/v1/admin/*).
 *
 * Two rules apply to every admin call:
 *  - it runs against the admin host, not the logged in company's host, and
 *  - it carries the selected company's code in the X-Company-Code header.
 *
 * The code comes from the /v1/admin/clients response. Company scoped admin pages
 * carry it in their own URL; the stored one is the fallback for admin tools that
 * aren't opened from a company page.
 */

import { getAdminApiEndpoint, getAdminCompanyCode } from "../config/config";

export const ADMIN_COMPANY_CODE_HEADER = "X-Company-Code";

// Standard headers for an admin call. The company code is left off when none is
// known yet (nothing selected) and for the calls that aren't company scoped.
export const adminHeaders = (jwt, companyCode = getAdminCompanyCode()) => {
  const headers = {
    Authorization: `Bearer ${jwt}`,
    "Content-Type": "application/json",
  };

  if (companyCode) {
    headers[ADMIN_COMPANY_CODE_HEADER] = companyCode;
  }

  return headers;
};

// Fetches the company list. Not company scoped - this is the call that hands out
// the codes, so it deliberately sends no X-Company-Code header.
export const fetchAdminClients = async jwt => {
  const response = await fetch(getAdminApiEndpoint("/v2/admin/clients"), {
    method: "GET",
    headers: adminHeaders(jwt, ""),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch clients: ${response.status}`);
  }

  const result = await response.json();
  const data = result.data;
  return data?.clients || data || [];
};
